import React, { SVGAttributes } from 'react'

const SvgCaretDown = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="7px" height="4px" viewBox="0 0 7 4" {...props}>
    <path
      fill="#313537"
      d="M1.058.214a.635.635 0 0 0-.876 0 .585.585 0 0 0 0 .846l2.86 2.765a.635.635 0 0 0 .877 0l2.9-2.803a.585.585 0 0 0 0-.847.635.635 0 0 0-.877 0L3.48 2.555 1.058.213z"
    />
  </svg>
)

export default SvgCaretDown
